import React, { memo, useContext, useEffect, useState } from 'react'
import { Button, Card, Input, Modal, Space, Table } from 'antd'
import Column from 'antd/lib/table/Column'
import {
  EditOutlined,
  DeleteOutlined,
  ExclamationCircleOutlined,
  PlusOutlined,
  ProfileOutlined
} from '@ant-design/icons'
import ChemicalComponentModal from '@/components/ChemicalComponentModal'
import { ChemicalComponent } from '@/services/chemical-component'
import { projectContext } from '@/layouts/MainLayout'
import { useRequest } from 'ahooks'
import ChemicalComponentDetailModal from '@/components/ChemicalComponentDetailModal'

const ChemicalComponentList = memo((props: any) => {
  const { projectId } = useContext(projectContext)
  const { data: res, loading, refresh } = useRequest(() => ChemicalComponent.get({ pId: projectId }))
  const [data, setData] = useState<ChemicalComponent.Modal[]>(res as any)
  const [text, setText] = useState('')

  useEffect(() => {
    if (!res) return
    if (!text) {
      setData([...res])
      return
    }
    const search = text.toLowerCase()
    const tableData = res.filter(
      (item) => item.name?.toLowerCase().indexOf(search) > -1 || item.formula?.toLowerCase().indexOf(search) > -1
    )
    setData(tableData)
  }, [res, text])

  const toCreate = (values) => {
    return ChemicalComponent.create(values, { pId: projectId })
  }

  const toUpdate = (values, component) => {
    return ChemicalComponent.update(values, { pId: projectId, id: component.id })
  }

  return (
    <Card>
      <Table
        bordered
        pagination={{ pageSize: 30 }}
        size='small'
        loading={loading}
        dataSource={data as any}
        rowKey={(record) => record.id}
        title={() => {
          return (
            <div className='flex-space-btw'>
              <div style={{ fontWeight: 'bold' }}>Chemical Components</div>
              <div>
                <Input
                  placeholder='Search by Name and Formula'
                  defaultValue={text}
                  onChange={(e) => setText(e.target.value)}
                  style={{ width: 300 }}
                  allowClear
                  className='mr-2'
                />
                <ChemicalComponentModal
                  request={toCreate}
                  trigger={<Button icon={<PlusOutlined />} />}
                  onSuccess={() => refresh()}
                />
              </div>
            </div>
          )
        }}
      >
        <Column title='Name' dataIndex='name' key='name' align={'center'} />
        <Column title='Formula' dataIndex='formula' key='formula' align={'center'} />
        <Column title='Molecular Weight' dataIndex='mw' key='molecularWeight' align={'center'} />
        <Column title='Critical Pressure' dataIndex='pc' key='criticalPressure' align={'center'} />
        <Column title='Critical Temperature' dataIndex='tc' key='criticalTemperature' align={'center'} />
        <Column title='Acentric Factor' dataIndex='af' key='af' align={'center'} />
        <Column title='CAS No.' dataIndex='cas' key='cas' align={'center'} />
        <Column
          title='Actions'
          align={'center'}
          dataIndex='id'
          render={(id, record: any, index) => {
            return (
              <Space>
                <ChemicalComponentDetailModal trigger={<ProfileOutlined title='View' />} component={record} />
                <ChemicalComponentModal
                  request={toUpdate}
                  component={record}
                  trigger={<EditOutlined />}
                  onSuccess={() => refresh()}
                />
                <DeleteOutlined
                  onClick={() => {
                    Modal.confirm({
                      icon: <ExclamationCircleOutlined />,
                      content: 'Are you sure to delete?',
                      onOk: async () => {
                        try {
                          await ChemicalComponent.remove(id)
                          refresh()
                          return true
                        } catch (error) {
                          return false
                        }
                      }
                    })
                  }}
                />
              </Space>
            )
          }}
        />
      </Table>
    </Card>
  )
})

export default ChemicalComponentList
